import React, { useContext } from 'react';
import { AuthContext } from '../../../context/auth';

import { BoughtMoviesModel } from '../../../pages/boughtMovies/query/types';
import { BigButton } from '../../UI/BigButton';

import getMoviePriceLabel from '../../../helpers/moviePrice/getMoviePriceLabel';
import getMoviePrice from '../../../helpers/moviePrice/getMoviePrice';

type DownloadHDButtonType = {
  movie: BoughtMoviesModel;
  setShow: (value: boolean) => void;
  setSelectedMovie:(movie: BoughtMoviesModel) => void;
  setSelectedButton:(value: string) => void;
  setOrderVisibility: (value: boolean) => void;
  setSelectedPrice:(value: number) => void;

}

const DownloadHDButton:React.FC<DownloadHDButtonType> = (props) => {
  const {movie,setShow,setSelectedMovie,setSelectedButton,setOrderVisibility,setSelectedPrice} = props;

  const authContext = useContext(AuthContext);
  const { user } = authContext;

  const isHdDownloadFree = movie['download-hd']?.price === 0;

  const hdDownloadAccessText = `Download (HD) FÜR ${movie['download-hd']?.hours_to_expire}`;
  const hdDownloadPurchaseText = getMoviePriceLabel(movie, 'download-hd', 'KAUFEN HD FÜR');
  const hdDownloadCtaText  = isHdDownloadFree ? hdDownloadAccessText : hdDownloadPurchaseText ;

  const onClick = () => {
    setSelectedMovie(movie);
    setSelectedButton('hd');
    {isHdDownloadFree ? setShow(true) : setOrderVisibility(true)}
    {!isHdDownloadFree && setSelectedPrice(getMoviePrice(movie, 'download-hd'))}
  }

  return (
    <BigButton
      active={isHdDownloadFree}
      sm={6}
      md={user.subscribed === false && movie.banner === 'blue-movie-plus' ? 3 : 4}
      text={hdDownloadCtaText}
      icon="fa fa-download"
      onClick={onClick} />
  )
}

export default DownloadHDButton